<template>
  <div class="companyApprovalBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="企业名称：" prop="companyName">
        <Input v-model="formCustom.companyName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="统一社会信用代码：" prop="organizationCode">
        <Input v-model="formCustom.organizationCode" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="行业类型：" prop="industryType">
        <Select v-model="formCustom.industryType" clearable filterable placeholder="请选择" style="width: 200px">
          <Option v-for="item in industryTypeList" :value="item.itemValue">{{ item.itemText }}</Option>
        </Select>
      </Form-item>
      <Form-item label="法人姓名：" prop="owner">
        <Input v-model="formCustom.owner" :maxlength="50" clearable placeholder="请输入" style="width: 200px"></Input>
      </Form-item>
      <Form-item label="企业注册地：" prop="countyCode">
        <Cascader v-model="formCustom.countyCode" :data="areaData" change-on-select filterable
                  not-found-text='暂无下级数据，请创建'
                  style="width: 200px" @on-change="changeCountyCode"></Cascader>
      </Form-item>
      <Form-item label="企业规模：" prop="companyScale">
        <Select v-model="formCustom.companyScale" clearable filterable placeholder="请选择" style="width: 200px">
          <Option v-for="item in companyScaleList" :value="item.itemValue">{{ item.itemText }}</Option>
        </Select>
      </Form-item>
      <Form-item label="申请人姓名：" prop="createUserName">
        <Input v-model="formCustom.createUserName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="申请人手机号：" prop="createUserTelephone">
        <Input v-model="formCustom.createUserTelephone" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="审批人姓名：" prop="approvalUserName">
        <Input v-model="formCustom.approvalUserName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="审批状态：" prop="approvalStatus">
        <Select v-model="formCustom.approvalStatus" clearable filterable placeholder="请选择" style="width: 200px">
          <Option value="2">待审批</Option>
          <Option value="3">审批通过</Option>
          <Option value="4">审批拒绝</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button type="primary" @click="approvalDialogShow()">批量审批</Button>
    </div>
    <div>
      <Table :columns="companyApprovalColumns" :data="companyApprovalTableData" :loading="loading" aria-describedby=""
             aria-hidden="true" border @on-selection-change="selectionChange">
        <template slot="countyName" slot-scope="{ row }">
          <span>{{ row.provinceName + row.cityName + row.countyName }}</span>
        </template>
        <template slot="businesslicenseCodeUrl" slot-scope="{ row }">
          <a @click="handlePreView(row.businesslicenseCodeUrl)">预览</a>
        </template>
        <template slot="approvalStatus" slot-scope="{ row }">
          <span>{{
              row.approvalStatus === 2 ? '待审批' : row.approvalStatus === 3 ? '审批通过' : row.approvalStatus === 4 ? '审批拒绝' : '其他'
            }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="row.approvalStatus === 2" size="small" type="text" @click="approvalDialogShow(row)">审批
          </Button>
          <Button size="small" type="text" @click="detailDialogShow(row)">详情</Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
    <el-dialog :visible.sync="approvalDialogVisible" title="企业审批" width="30%">
      <Form ref="approvalForm" :label-width="120" :model="formCustom">
        <Form-item label="审批结果：">
          <RadioGroup v-model="approvalStatus">
            <Radio label="3">通过</Radio>
            <Radio label="4">拒绝</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="审批意见：">
          <Input v-model="approvalIdea" :rows="4" placeholder="请输入审批意见" type="textarea"/>
        </Form-item>
        <Form-item>
          <Button class="next" type="primary" @click="approval">提交</Button>
        </Form-item>
      </Form>
    </el-dialog>
    <el-dialog :visible.sync="detailDialogVisible" title="查看企业" width="730px">
      <company-approval-detail :key="row.companyId" :row="row" @detailSuccess="detailSuccess"></company-approval-detail>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from '@/libs/handlePermission.ts'
import {allDivisionTree} from '@/api/public'
import {companyApproval, companyPage} from '@/api/organization'
import {companyScaleList, industryTypeList} from "@/api/authority"
import companyApprovalDetail from '@/views/organization/companyApprovalDetail.vue'

export default {
  name: 'companyApproval',
  components: {
    companyApprovalDetail
  },
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: '',
      formCustom: {
        companyName: '',
        organizationCode: '',
        owner: '',
        industryType: '',
        countyCode: [],
        companyScale: '',
        createUserName: '',
        createUserTelephone: '',
        approvalUserName: '',
        approvalStatus: ''
      },
      companyApprovalColumns: [
        {type: 'selection', width: 60, align: 'center'},
        {type: 'index', title: '序号', align: 'center'},
        {title: '企业名称', key: 'companyName', align: 'center'},
        {title: '统一社会信用代码', key: 'organizationCode', align: 'center'},
        {title: '行业类型', key: 'industryTypeName', align: 'center'},
        {title: '法人姓名', key: 'owner', align: 'center'},
        {title: '企业注册地', key: 'countyName', slot: 'countyName', align: 'center'},
        {title: '企业规模(人)', key: 'companyScaleName', align: 'center'},
        {title: '申请人姓名', key: 'createUserName', align: 'center'},
        {title: '申请人手机号', key: 'createUserTelephone', align: 'center'},
        {title: '营业执照', key: 'businesslicenseCodeUrl', slot: 'businesslicenseCodeUrl', align: 'center'},
        {title: '审批状态', key: 'approvalStatus', slot: 'approvalStatus', align: 'center'},
        {title: '审批人', key: 'approvalUserName', align: 'center'},
        {title: '审批时间', key: 'approvalTime', align: 'center'},
        {title: '操作', slot: 'action', align: 'center', fixed: 'right'}
      ],
      companyApprovalTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: '',
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      approvalDialogVisible: false,
      approvalStatus: '',
      approvalIdea: '',
      detailDialogVisible: false
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      companyPage({
        current: 1,
        size: 10
      }).then((res) => {
        this.changeData(res)
      })
      allDivisionTree().then((response) => {
        this.areaData = response.data.data
      })
      industryTypeList().then((response) => {
        this.industryTypeList = response.data.data
      })
      companyScaleList().then((response) => {
        this.companyScaleList = response.data.data
      })
    },
    selectionChange(rows) {
      this.companyIds = ''
      if (rows && rows.length > 0) {
        let ids = []
        rows.forEach(row => {
          ids.push(row.companyId)
        })
        this.companyIds = ids.join(",")
      }
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      companyPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.companyApprovalTableData = res.data.data.records
      this.loading = false
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.page = val
      companyPage({
        current: val,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom
      };
      if (this.formCustom.countyCode.length > 0) {
        data.countyCode = this.countyCode
      }
      this.loading = true
      this.pageSize = val
      companyPage({
        current: 1,
        size: this.pageSize,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    changeCountyCode(v, d) {
      this.countyCode = d.slice(-1)[0].id
    },
    approvalDialogShow(row) {
      if (row?.companyId) {
        let ids = []
        ids.push(row.companyId)
        this.companyIds = ids.join(",")
      }
      if (this.companyIds === null || this.companyIds.length === 0) {
        this.$Message.warning('请选择一条记录！')
        return;
      }

      this.approvalDialogVisible = true
    },
    approval() {
      if (this.approvalStatus === '4' && (this.approvalIdea === null || this.approvalIdea === '')) {
        this.$Message.warning('请填写审批意见！')
        return;
      }

      companyApproval({
        companyIds: this.companyIds,
        approvalStatus: this.approvalStatus,
        approvalIdea: this.approvalIdea
      }).then((res) => {
        if (res.data.success === false) {
          this.$Message.error(res.data.msg)
        } else {
          this.$Message.success(res.data.msg)
          this.init()
        }
      })
      this.approvalDialogVisible = false
    },
    detailDialogShow(row) {
      this.row = row
      this.detailDialogVisible = true
    },
    detailSuccess() {
      this.detailDialogVisible = false
    },
    /** 预览按钮操作 */
    handlePreView(val) {
      window.open(this.$getImgUrl + val, '_blank')
    }
  }
}
</script>
<style lang="less">
.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 80%
}
</style>
